module.exports = __webpack_public_path__ + "static/media/logo_admitere_UEB.d8b49668.png";